module.exports = __webpack_public_path__ + "static/media/OpenSeas_web_1_preview.d085e782.jpg";